/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import "jspdf-autotable";
import TableHeader from "../Common/TableHeader";
import Loader from "../Common/Loader";
import TransactionsTable from "../Common/Transactions/TransactionsTable";
import Pagination from "../Common/Pagination";
import TransactionsSearchForm from "../Common/Transactions/TransactionsSearchForm";
import ajaxBank from "../../util/remote/ajaxBank";
import { Link } from "react-router-dom";

function PocketMoneyConversions() {
  const [pmConversions, setPmConversions] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [page,setPage] = useState(1)
  const [meta,setMeta] = useState([])
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const getPMConversions = async (currentPage) => {
      setLoading(true);
      const server_response = await ajaxBank.fetchPMConversions(currentPage);
      setLoading(false);
      if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setPmConversions(server_response.details.data || []);
      } else {
        setPmConversions([]);
      }
  };

  const searchPMConversions = async (e) => {
      if (e) {
        e.preventDefault();
      }
      setLoading2(true);
      const server_response = await ajaxBank.searchPMConversions(searchTerm,startDate,endDate,page);
      setLoading2(false);
      if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setPmConversions(server_response.details.data || []);
      } else {
        setPmConversions([]);
      }
      
  };

  const setConversions = (e) => {
    e.preventDefault();
    setSearchTerm("");
    setStartDate("");
    setEndDate("");
    setPage(1);
    getPMConversions(1);
    
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const headers = [
    { label: "Transaction Date", key: "created_at" },
    { label: "Transactors", key: "transactors"},
    { label: "Amount", key: "amount" },
    { label: "Transaction Number", key: "transaction_number" }
  ];

  useEffect(() => {
    if (searchTerm || startDate || endDate) {
      searchPMConversions();
    } else {
      getPMConversions(page);
    }
  }, [page]);

  return (
    <>
      <div class="heading-layout1 mg-b-5">
        <TableHeader
          subtitle="List of all the pocket money conversions sorted by the most recent"   
        />
        <div class="dropdown">
          <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
         
        </div>
      </div>

      <TransactionsSearchForm searchTerm={searchTerm} setSearchTerm={setSearchTerm} startDate={startDate}
         setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} searchTransactions={searchPMConversions}
         setTransactions={setConversions} setPage={setPage} searchTermPlaceholder="Enter transaction number..."/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
        {loading || loading2 ? (
          <Loader />
        ) : (
          <TransactionsTable headers={headers} data={pmConversions} isPMTransaction={true}/>

        )}
      </div>

      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
    </>
     
  );
}

export default PocketMoneyConversions;
